import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  execute3ue2b8qx506vx as execute,
  ActionPipe2nmxwvx2ocjhz as ActionPipe,
} from '../../../../../testmints-action-async/com/zegreatrob/testmints/action/ActionPipe.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  logAsync2a3lioxm56cip as logAsync,
  ActionLoggingSyntax2p3dfvwppstk6 as ActionLoggingSyntax,
} from './ActionLoggingSyntax.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KotlinLogging_getInstance23m15hivuqa9t as KotlinLogging_getInstance } from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/KotlinLogging.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_theLogger() {
  _init_properties_LoggingActionPipe_kt__jmuje7();
  var tmp0 = theLogger$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('theLogger', 0, tmp, _get_theLogger_$ref_r8fuo1(), null);
  return tmp0.n3();
}
var theLogger$delegate;
function LoggingActionPipe$execute$slambda(this$0, $dispatcher, $action) {
  return constructCallableReference(function *(it, $completion) {
    return yield* execute.call(this$0, $dispatcher, $action, $completion);
  }, 1);
}
var LoggingActionPipeClass;
function LoggingActionPipe() {
  if (LoggingActionPipeClass === VOID) {
    class $ {
      constructor(traceId) {
        this.c2j_1 = traceId;
        this.d2j_1 = get_theLogger();
      }
      t2i() {
        return this.c2j_1;
      }
      s2i() {
        return this.d2j_1;
      }
      *t2e(dispatcher, action, $completion) {
        var tmp;
        try {
          tmp = yield* this.u2i(action, LoggingActionPipe$execute$slambda(this, dispatcher, action), $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var bad = $p;
            this.d2j_1.x2f(bad, () => 'Error executing ' + getKClassFromExpression(action).j1());
            throw bad;
          } else {
            throw $p;
          }
        }
        return tmp;
      }
    }
    protoOf($).u2i = logAsync;
    initMetadataForClass($, 'LoggingActionPipe', VOID, VOID, [ActionPipe(), ActionLoggingSyntax()], [2]);
    LoggingActionPipeClass = $;
  }
  return LoggingActionPipeClass;
}
function theLogger$delegate$lambda() {
  _init_properties_LoggingActionPipe_kt__jmuje7();
  return KotlinLogging_getInstance().e2f('ActionLogger');
}
function _get_theLogger_$ref_r8fuo1() {
  return constructCallableReference(() => get_theLogger(), 0, 0, 40);
}
var properties_initialized_LoggingActionPipe_kt_pe2ral;
function _init_properties_LoggingActionPipe_kt__jmuje7() {
  if (!properties_initialized_LoggingActionPipe_kt_pe2ral) {
    properties_initialized_LoggingActionPipe_kt_pe2ral = true;
    theLogger$delegate = lazy(theLogger$delegate$lambda);
  }
}
//region block: exports
export {
  LoggingActionPipe as LoggingActionPipenpslk1461eyq,
};
//endregion

//# sourceMappingURL=LoggingActionPipe.mjs.map
